import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '@service/auth/auth.service';
import {UserRole} from "@enum/user-roles/user-role";
import {filter, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ComposerGuard implements CanActivate {
  constructor(public authService: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isAuthenticated.pipe(
      filter(() => this.authService.currentRole !== null || !this.authService.isUserAuthenticated),
      map(() => {
        if (this.authService.currentUserPermission?.composerAllowed) {
          return true;
        } else {
          this.router.navigate(['catalog-list'], {replaceUrl: true});
          return true;
        }

      })
    );
  }

}
